import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Card,
  Input,
  Button,
  Form,
  Select,
  message,
  Tabs,
} from "antd";
import storageUtils from "../../utils/storageUtils";
import { getTomorrowDateYYYYMMDD } from "../../utils/dateUtil";
import { req_add_pim_flexible_log_staff } from "../../api";
import PicturesWall from "./pictures-wall";

const Item = Form.Item;
class FlexibleLogSelfAddModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };

  state = {
    lock: false,
    workStatusList: [{ label: "上班", value: "WORK" }],
    reasonList: [{ label: "工作日", value: "工作日" }],
    selectedWorkStatus: "WORK",
    selectedReason: "工作日",
    inputStaffCode: this.props.user.userCode,
    inputDate: getTomorrowDateYYYYMMDD(new Date()),
    inputBunchIn: "0600",
    inputBunchOut: "1500",
    inputRestStart: "1200",
    inputRestEnd: "1300",
    inputRecordDescription: "",
    inputGroupDepartment: "",
    inputGroupTable: "",
    inputAccordingDescription: "單日作息調整申請",
    item: {
      ClockType: "FLEXIBLE",
      StaffCode: this.props.user.userCode,
      FlexibleDate: getTomorrowDateYYYYMMDD(new Date()),
      FlexibleClockIn: "0600",
      FlexibleClockOut: "1500",
      FlexibleReason: "工作日",
      FlexibleStatus: "WORK",
      ApplyStatus: "APPLY",
      RestStartTime: "1200",
      RestEndTime: "1300",
      RecordDescription: "",
      GroupDepartment: "",
      GroupTable: "",
      AccordingDescription: "單日作息調整申請",
      RecordCreatorCode: this.props.user.userCode,
      ReasonFileUrl: "",
    },
  };

  constructor(props) {
    super(props);
    this.get_flexible_images = React.createRef();
  }

  api_add_item = async (item) => {
    const result = await req_add_pim_flexible_log_staff(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      message.success("申請調整作息時間成功");
    } else {
      message.error("申請調整作息時間失敗");
      this.setState({ lock: false });
    }
  };

  // 操作互動處理 //////////////////////////////////////////////
  handleWorkStatusChange = (value) => {
    //console.log(value);
    this.setState({ selectedWorkStatus: value });
  };

  handleReasonChange = (value) => {
    //console.log(value);
    this.setState({ selectedReason: value });
  };

  onFinish = (values) => {
    const { item, selectedWorkStatus, selectedReason } = this.state;
    //console.log("Success:", values);
    if (values.inputRecordDescription.length === 0) {
      message.error("請輸入調整作息時間原因");
      return;
    }
    if (this.checkTime(values.inputBunchIn, values.inputBunchOut)) {
      item.StaffCode = values.inputStaffCode;
      item.FlexibleDate = values.inputDate;
      item.FlexibleClockIn = values.inputBunchIn;
      item.FlexibleClockOut = values.inputBunchOut;
      item.RestStartTime = values.inputRestStart;
      item.RestEndTime = values.inputRestEnd;
      item.FlexibleReason = selectedReason;
      item.FlexibleStatus = selectedWorkStatus;
      item.RecordDescription = values.inputRecordDescription;
      item.AccordingDescription = values.inputAccordingDescription;

      const reasonFile = this.get_flexible_images.current.output_files();
      if (typeof reasonFile[0] === "undefined") {
        message.error("尚未上傳佐證資料");
      } else {
        if (reasonFile[0].indexOf("rc-upload") !== -1) {
          message.error("資料驗證失敗，請重傳");
        } else {
          item.ReasonFileUrl = reasonFile[0];
          this.setState({ lock: true });
          this.api_add_item(item);
        }
      }
    }
  };

  checkTime = (starttime, endtime) => {
    // 檢查輸入是否為四位數字
    if (!this.validateInput(starttime) || !this.validateInput(endtime)) {
      message.error("請輸入四位數字的時間格式，例如0800");
      return false;
    }

    // 將輸入轉換為時間格式
    const startTime = parseInt(starttime.slice(0, 2));
    const startMinute = parseInt(starttime.slice(2, 4));
    const endTime = parseInt(endtime.slice(0, 2));
    const endMinute = parseInt(endtime.slice(2, 4));

    // 檢查時間是否有效
    if (
      !this.isValidTime(startTime, startMinute) ||
      !this.isValidTime(endTime, endMinute)
    ) {
      alert("時間格式錯誤，請確保時間在00:00至23:59之間");
      return false;
    }

    // 檢查起始時間是否早於結束時間
    if (
      !this.isStartTimeBeforeEndTime(startTime, startMinute, endTime, endMinute)
    ) {
      alert("起始時間不能晚於結束時間");
      return false;
    }
    return true;
  };

  validateInput = (input) => {
    return /^\d{4}$/.test(input);
  };

  // 驗證時間是否有效
  isValidTime = (hour, minute) => {
    return hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59;
  };

  // 檢查起始時間是否早於結束時間
  isStartTimeBeforeEndTime = (startHour, startMinute, endHour, endMinute) => {
    if (startHour < endHour) return true;
    if (startHour === endHour && startMinute < endMinute) return true;
    return false;
  };

  onDateChange = (date, dateString) => {
    this.setState({ weekday: dateString });
  };

  render() {
    const ReasonFileUrl = [];
    const fileUrlPath = "/api/UploadFile/AddInsideMediaFile";
    const {
      inputStaffCode,
      inputBunchIn,
      inputBunchOut,
      inputRecordDescription,
      inputRestStart,
      inputRestEnd,
      inputAccordingDescription,
      selectedReason,
      selectedWorkStatus,
      workStatusList,
      reasonList,
      inputDate
    } = this.state;

    return (
      <Card>
        <Form onFinish={this.onFinish}>
          <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab="基本資料" key="1">
              <>
                {" "}
                <Item
                  label="日期分類"
                  style={{ height: "10px" }}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Select
                    defaultValue={selectedReason}
                    onChange={this.handleReasonChange}
                    style={{
                      width: "100%",
                    }}
                    disabled
                    options={reasonList}
                  />
                </Item>
                <Item
                  label="作息狀態"
                  style={{ height: "10px" }}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Select
                    defaultValue={selectedWorkStatus}
                    onChange={this.handleWorkStatusChange}
                    disabled
                    style={{
                      width: "100%",
                    }}
                    options={workStatusList}
                  />
                </Item>
                <Item
                  label="作息日期"
                  style={{ height: "10px" }}
                  name="inputDate"
                  initialValue={inputDate}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="日期格式: 20240101" />
                </Item>
                <Item
                  label="職工職號"
                  style={{ height: "10px" }}
                  name="inputStaffCode"
                  initialValue={inputStaffCode}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="輸入職工職號" disabled />
                </Item>
                <Item
                  label="作息起始時間"
                  style={{ height: "10px" }}
                  name="inputBunchIn"
                  initialValue={inputBunchIn}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="時間格式: 0800" />
                </Item>
                <Item
                  label="作息結束時間"
                  style={{ height: "10px" }}
                  name="inputBunchOut"
                  initialValue={inputBunchOut}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="時間格式: 1700" />
                </Item>
                <Item
                  label="作息說明"
                  style={{ height: "10px" }}
                  name="inputRecordDescription"
                  initialValue={inputRecordDescription}
                >
                  <Input placeholder="" />
                </Item>
              </>
            </Tabs.TabPane>
            <Tabs.TabPane tab="其他資料" key="2">
              <>
                {" "}
                <Item
                  label="休息起始時間"
                  style={{ height: "10px" }}
                  name="inputRestStart"
                  initialValue={inputRestStart}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="時間格式: 1730" />
                </Item>
                <Item
                  label="休息結束時間"
                  style={{ height: "10px" }}
                  name="inputRestEnd"
                  initialValue={inputRestEnd}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="時間格式: 1800" />
                </Item>
                <Item
                  label="依據說明"
                  style={{ height: "10px" }}
                  name="inputAccordingDescription"
                  initialValue={inputAccordingDescription}
                >
                  <Input placeholder="" disabled />
                </Item>
                <PicturesWall
                  ref={this.get_flexible_images}
                  images_source={ReasonFileUrl}
                  api_url={fileUrlPath}
                  self_filename="原由佐證圖檔"
                ></PicturesWall>
                <Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="wave"
                    block
                    disabled={this.state.lock}
                  >
                    {"送出"}
                  </Button>
                </Item>
              </>
            </Tabs.TabPane>
          </Tabs>
        </Form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(FlexibleLogSelfAddModal);
